<template>
  <a
    v-if="row.receipt_status == 'UP_LOAD' || row.receipt_status == 'RECEIVED'"
    style="position: relative"
  >
    <img src="../../assets/images/huidan.png" alt="" class="huidan-img" />
    <viewer :images="images_urls" style="position: relative">
      <div v-if="invoice">
        <img
          v-for="(src, index) in images_urls"
          :src="src"
          :key="index"
          class="yulanws"
        />
      </div>
      <div v-else>
        <img
          v-for="(src, index) in images_urls"
          :src="src"
          :key="index"
          class="yulanw"
        />
      </div>
    </viewer>
  </a>
</template>
<script>
import { isSuccess } from "@/assets/js/utils";
export default {
  data() {
    return {
      images_urls: [],
      invoice: false,
    };
  },
  props: {
    row: {},
    isRelated: false,
  },
  created() {
    this.bindImage();
    if (this.$route.path == "/settle/ticket-apply") {
      this.invoice = true;
    } else {
      this.invoice = false;
    }
  },
  watch: {
    row: function (newVal, oldVal) {
      this.bindImage();
    },
    isRelated: function (newVal, oldVal) {
      this.isRelated = isRelated;
    },
  },
  methods: {
    bindImage() {
      let id = "";
      if (
        this.row.receipt_status == "UP_LOAD" ||
        this.row.receipt_status == "RECEIVED"
      ) {
        if (this.isRelated == true) {
          id = this.row.waybill_related_pid;
        } else {
          id = this.row.pid;
        }
        api("invoice.receipt.image.query", { id: id }).then((res) => {
          let data;
          if ((data = isSuccess(res))) {
            this.img_url = [];
            this.images_urls = [];
            if (data.images_urls !== null) {
              data.images_urls.forEach((item) => {
                if (item.includes("doc.haietong.")) {
                  let imgurl = item.split("?Expires");
                  this.images_urls.push(imgurl[0]);
                } else if (item.includes("zeyi-tms")) {
                  let imgurl = item.split("?x-oss-process");
                  this.images_urls.push(imgurl[0]);
                } else {
                  this.images_urls.push(item);
                }
              });
            }
          }
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.yulanw {
  width: 25px;
  height: 20px;
  position: absolute;
  top: -27px;
  left: 94px;
  opacity: 0;
}

@media screen and (min--moz-device-pixel-ratio: 0) {
  .yulanw {
    width: 25px;
    height: 20px;
    position: absolute;
    top: -22px;
    opacity: 0;
    left: 59%;
  }
}
.yulanws {
  width: 25px;
  height: 20px;
  position: absolute;
  top: -27px;
  left: 75px;
  opacity: 0;
}
.huidan-img {
  width: 17px;
  height: 17px;
  /* margin-left: 5%; */
  position: absolute;
  left: 10px;
  top: -2px;
}
</style>



// WEBPACK FOOTER //
// src/components/customer/customer-view.vue